import Vue from 'vue'
import { getImageUrl } from '../enjuphotos'

Vue.filter('enjuphotosUrl', (imagePublicId, preset, { slug } = {}) => {
  return slug ? getImageUrl(imagePublicId, preset, slug) : getImageUrl(imagePublicId, preset)
})
